import React, { Component } from 'react'
import PropTypes from 'prop-types'
import gql from 'graphql-tag'
import { Query, ApolloConsumer, withApollo } from 'react-apollo'
import Select from 'react-select'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import FormGroup from '@material-ui/core/FormGroup'
import TextField from '@material-ui/core/TextField'
import FormControl from '@material-ui/core/FormControl'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormHelperText from '@material-ui/core/FormHelperText'
import RadioGroup from '@material-ui/core/RadioGroup'
import Radio from '@material-ui/core/Radio'
import { withStyles } from '@material-ui/core/styles'
import { DateTimePicker } from 'material-ui-pickers'
import CustomTabs from '../../Modules/CustomTabs'
import withSharedSnackbar from '../../HOCs/withSharedSnackbar'
import getLoginId from '../../../utils/getLoginId'
import moment from 'moment'
import Loader from '../../../components/common/Loader'
import ConfirmationalDialog from '../../common/ConfirmationDialog'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import CardContent from '@material-ui/core/CardContent'
import CardActions from '@material-ui/core/CardActions'
import { Checkbox } from '@material-ui/core'
import Countries from '../../Modules/Countries'
import States from '../../Modules/States'

const styles = theme => ({
  root: {
    padding: theme.spacing.unit * 4,
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing.unit * 2
    },
    flexGrow: 1
  },
  italicizedText: {
    fontStyle: 'italic'
  }
})

const ADD_CLIENTS = gql`
  mutation clientSignup(
    $username: String!
    $password: String!
    $accountType: String!
    $clientName: String!
    $email: String!
    $contactPerson: String!
    $contactNumber: String!
    $address: String!
    $city: String!
    $state: Int!
    $country: Int!
    $pincode: Int
    $panNumber: String
    $gst: String
    $planId: Int
    $solution: String!
    $billingMode: Int!
    $salesPersonId: Int
    $clientType: String!
    $timezone: String!
    $lat: Float
    $long: Float
    $partnerLoginId: Int
    $resellerLoginId: Int
    $licenseTypeId: Int
    $typeOfClient: ClientPartnerType
    $expiryDate: String
    $registrationType: String
    $secondaryContactName: String
    $secondaryContactNumber: String
    $secondaryEmail: String
    $shippingAddress: String
    $shippingCountry: Int
    $shippingState: Int
    $shippingCity: String
    $shippingPincode: Int
    $minimumTrackedDays: Int!
    $packetThreshold: Int
    $prorata: Int!
    $addressEffectiveDate: String
  ) {
    clientSignup(
      username: $username
      password: $password
      accountType: $accountType
      clientName: $clientName
      email: $email
      contactPerson: $contactPerson
      contactNumber: $contactNumber
      address: $address
      city: $city
      state: $state
      country: $country
      pincode: $pincode
      panNumber: $panNumber
      gst: $gst
      planId: $planId
      solution: $solution
      billingMode: $billingMode
      clientType: $clientType
      timezone: $timezone
      lat: $lat
      long: $long
      partnerLoginId: $partnerLoginId
      resellerLoginId: $resellerLoginId
      licenseTypeId: $licenseTypeId
      typeOfClient: $typeOfClient
      expiryDate: $expiryDate
      registrationType: $registrationType
      secondaryContactName: $secondaryContactName
      secondaryContactNumber: $secondaryContactNumber
      secondaryEmail: $secondaryEmail
      shippingAddress: $shippingAddress
      shippingCountry: $shippingCountry
      shippingState: $shippingState
      shippingCity: $shippingCity
      shippingPincode: $shippingPincode
      minimumTrackedDays: $minimumTrackedDays
      packetThreshold: $packetThreshold
      prorata: $prorata
      addressEffectiveDate: $addressEffectiveDate

      salesPersonId: $salesPersonId
    )
  }
`

const GET_ALL_PLANS = gql`
  query getAllPlans($partnerLoginId: Int!) {
    allPlans: getAllPlans(partnerLoginId: $partnerLoginId) {
      id
      planName
    }
  }
`
const GET_COUNTRIES = gql`
  query {
    allCountries {
      country_id
      name
    }
  }
`

const GET_STATES_FOR_COUNTRY = gql`
  query getStatesByCountryId($countryId: Int!) {
    allStatesByCountryId(country_id: $countryId) {
      name
      zone_id
    }
  }
`
// username validation
const GET_USERNAME = gql`
  query checkUsername($username: String!) {
    checkUsername(username: $username)
  }
`

// Business name validation
const GET_CLIENT_NAME = gql`
  query checkClientName($clientName: String!) {
    checkClientName(clientName: $clientName)
  }
`

// Business name validation
const GET_CONTACTNO = gql`
  query checkClientContactNumber($contactNumber: String!) {
    checkClientContactNumber(contactNumber: $contactNumber)
  }
`

// Business email validation
const GET_EMAIL = gql`
  query checkClientEmail($email: String!) {
    checkClientEmail(email: $email)
  }
`

// Business pan validation
const GET_PAN_NUMBER = gql`
  query checkClientPanNumber($pan: String!) {
    checkClientPanNumber(panNumber: $pan)
  }
` // Business gst validation
const GET_GST_NUMBER = gql`
  query checkClientGST($gst: String!) {
    checkClientGST(GST: $gst)
  }
`

const GET_ALL_SALESPERSON = gql`
  query getAllSalesPerson($partnerLoginId: Int) {
    getAllSalesPerson(partnerLoginId: $partnerLoginId) {
      id
      name
    }
  }
`
const GET_GST_INFO = gql`
  query getGstDetails($gstNumber: String!) {
    getGstDetails(gstNumber: $gstNumber) {
      status
      panNumber
      companyName
      address
      pinCode
    }
  }
`

const SOLUTION_TYPES = [
  {
    value: 'API',
    label: 'API'
  },
  {
    value: 'PORTAL',
    label: 'PORTAL'
  }
]

const TYPE_OF_CLIENT = [
  {
    value: 'REAL',
    label: 'COMMERCIAL'
  },
  {
    value: 'DEMO',
    label: 'NON-COMMERCIAL'
  }
]

const CUSTOMER_TYPES = [
  {
    value: 'International',
    label: 'International'
  },
  {
    value: 'Registered',
    label: 'Registered'
  },
  {
    value: 'Unregistered',
    label: 'Unregistered'
  }
]

const BILLING_MODES = [
  {
    value: 1,
    label: 'PREPAID'
  },
  {
    value: 2,
    label: 'POSTPAID'
  }
]

class RegisterCustomer extends Component {
  constructor(props) {
    super(props)
    let timezoneLists = require('timezone-list').getTimezones()

    const timezoneList = timezoneLists.map(timezone => ({
      value: timezone,
      label: timezone
    }))

    this.state = {
      clientName: '',
      username: '',
      contactPerson: '',
      secondaryContactName: '',
      password: '',
      email: '',
      secondaryEmail: '',
      contactNumber: '',
      secondaryContactNumber: '',
      address: '',
      // address2: '',
      shippingAddress: '',
      // shippingAddress2: '',

      shippingPincode: '',

      city: '',
      shippingCity: '',
      state: '',
      country: '',
      shippingCountry: '',
      shippingState: '',
      pincode: '',
      pan: '',
      gst: '',
      isGstInfoAvailable: true,
      panNumber: '',
      gstCompanyName: '',
      plan: '',
      timezoneList: timezoneList,
      timezone: '',
      isEmailValid1: true,
      isEmailValid2: true,
      isPhonenoValid1: true,
      isPhonenoValid2: true,
      isAddressValid: true,
      isShippingAddressValid: true,
      isCityValid: true,
      isShippingCityValid: true,
      isPinValid: true,
      isPanValid: true,
      isGSTValid: true,
      isUsernameValid: true,
      isNameValid: true,
      isContactpValid1: true,
      isContactpValid2: true,
      isPasswordValid: true,
      isUsernameUnique: true,
      isCancelConfDialogOpen: false,
      isSaveConfDialogOpen: false,
      response: false,
      clientNameRes: '',
      isEmailExists: 'false',
      isPhoneExists: 'false',
      isPanExists: 'false',
      isGSTExists: null,
      emailRes2: '',
      phonenoRes1: '',
      phonenoRes2: '',
      usernameRes: '',
      panNoRes: '',
      typeOfClient: 'REAL',
      registrationType: 'International',
      customerType: '',
      isChecked: false,
      shipping: false,
      expiryDateTime: moment().add(1, 'week'),
      solution: '',
      billingMode: '',
      salesPerson: 0,
      minimumTrackedDays: 0,
      packetThreshold: 0,
      prorata: 0,
      addressEffectiveDate: null,
      allSalesPerson: [],
      shippingmode: false,
      isShippingPinvalid: true,
      gstErrorFieldText: ''
    }
  }

  componentDidMount = () => {
    this.getAllSalesPersonDetails()
  }

  handleInputChange = e => {
    let regExValue = new RegExp(/^[0-9a-zA-Z]+$/)
    // const { value } = e.target
    // console.log('input value', value)
    // console.log(this.state.country)
    this.setState({ [e.target.name]: e.target.value })
  }

  handleCheckboxChange = e => {
    const name = e.target.name

    this.setState(prev => ({
      isChecked: !prev.isChecked
    }))
  }
  handleProrataCheckboxChange = e => {
    this.state.prorata
      ? this.setState({ prorata: 0 })
      : this.setState({ prorata: 1 })
  }
  setProrata = e => {
    this.setState({ minimumTrackedDays: 1, packetThreshold: 1 })
  }

  handleShipping = e => {
    this.state.shippingmode
      ? this.setState({ shippingmode: false })
      : this.setState({ shippingmode: true })
    // this.setState(prev => ({ shipping: !prev.shipping }))

    this.state.shippingmode
      ? this.setState({ shippingCountry: '' })
      : this.setState({ shippingCountry: this.state.country })
    this.state.shippingmode
      ? this.setState({ shippingState: '' })
      : this.setState({ shippingState: this.state.state })

    this.state.shippingmode
      ? this.setState({ shippingAddress: '' })
      : this.setState({ shippingAddress: this.state.address })

    this.state.shippingmode
      ? this.setState({ shippingPincode: '' })
      : this.setState({ shippingPincode: this.state.pincode })

    this.state.shippingmode
      ? this.setState({ shippingCity: '' })
      : this.setState({ shippingCity: this.state.city })
  }

  handleProrata = e => {
    this.setState({ [e.target.name]: e.target.value, isStateChanged: true })
  }

  handleSolutionChange = solutionType => {
    // console.log('solution:', solutionType)
    if (!solutionType) {
      this.setState({ solution: '' })
    } else {
      this.setState({ solution: solutionType.value })
    }
  }

  handleCustomerTypeChange = customer => {
    // console.log('Customer', customer)
    if (!customer) {
      this.setState({ customerType: '' })
    } else {
      this.setState({
        customerType: customer.value,
        isGSTExists: null,
        isGSTValid: true,
        gst: '',
        panNumber: '',
        address: '',
        pincode: '',
        gstCompanyName: '',
        clientNameRes: '',
        isNameValid: true,
        isAddressValid: true,
        isPinValid: true
      })
    }
  }

  handleClientType = clientType => {
    if (!clientType) {
      this.setState({ typeOfClient: '' })
    } else {
      this.setState({
        typeOfClient: clientType.value
      })
    }
  }

  hanldeBillingModeChange = billingMode => {
    if (!billingMode) {
      this.setState({ billingMode: '' })
    } else {
      this.setState({ billingMode: billingMode.value })
    }
  }

  getAllSalesPersonDetails = async () => {
    const fetchSalesPersonData = await this.props.client.query({
      query: GET_ALL_SALESPERSON,
      variables: {
        partnerLoginId: getLoginId()
      }
    })
    const {
      data: { getAllSalesPerson }
    } = fetchSalesPersonData
    const salesPersonsDetails = getAllSalesPerson.map(salesPerson => ({
      value: salesPerson.id,
      label: salesPerson.name
    }))
    this.setState({ allSalesPerson: salesPersonsDetails })
  }

  handleSalesPersonChange = salesPerson => {
    // console.log('salesPerson', salesPerson)
    if (!salesPerson) {
      this.setState({ salesPerson: '' })
    } else {
      this.setState({ salesPerson: salesPerson.value })
    }
  }

  handleDateTimeChange = date => this.setState({ expiryDateTime: date })

  handleCountryChange = c => {
    if (!c) {
      this.setState({ country: '' })
    } else {
      this.setState({ country: c.value })
      this.state.shipping && this.setState({ shippingCountry: c.value })
    }
  }
  handleSecondaryCountryChange = c => {
    if (!c) {
      this.setState({ shippingCountry: '' })
    } else {
      this.setState({ shippingCountry: c.value })
    }
  }

  handlePlanChange = plan => {
    if (!plan) {
      this.setState({ plan: '' })
    } else {
      this.setState({ plan: plan.value })
    }
  }

  handleTimezoneChange = timezone => {
    if (!timezone) {
      this.setState({ timezone: '' })
    } else {
      this.setState({ timezone: timezone.value })
    }
  }

  handleStateChange = state => {
    this.setState({ state: state })
  }
  handleStateChangeTwo = state => {
    this.setState({ shippingState: state })
  }

  checkNameValidity = client => async event => {
    const regex = new RegExp(
      /^(?!\s)(?!.*\s$)(?=.*[a-zA-Z0-9])[a-zA-Z0-9 '~?!]{5,100}$/
    )
    const { data } = await client.query({
      query: GET_CLIENT_NAME,
      variables: { clientName: this.state.clientName }
    })

    this.setState({
      isNameValid:
        regex.test(this.state.name) &&
        this.state.name !== '' &&
        data.checkClientName === 'AVAILABLE'
    })

    if (this.state.name.length === 0) {
      this.setState({
        clientNameRes: 'Please enter the name'
      })
    } else if (
      this.state.name.length !== 0 &&
      regex.test(this.state.name) === false
    ) {
      this.setState({
        clientNameRes:
          'Name can be characters or Number between 5-32 characters'
      })
    } else if (data.checkClientName !== 'AVAILABLE') {
      // console.log('availabe')
      this.setState({ clientNameRes: 'Name already exist' })
    }
  }

  checkUsernameValidity = client => async event => {
    const regex = new RegExp(/^[a-zA-Z0-9.\-_$@*!]{5,32}$/)
    const { data } = await client.query({
      query: GET_USERNAME,
      variables: { username: this.state.username }
    })

    this.setState({
      isUsernameUnique: data.checkUsername === 'AVAILABLE',
      isUsernameValid:
        regex.test(this.state.username) &&
        this.state.username !== '' &&
        data.checkUsername === 'AVAILABLE'
    })

    if (regex.test(this.state.username) === false) {
      this.setState({
        usernameRes:
          'Username Can be character number special chatcters(-_$@*!) without blank space between 5-32 charcters'
      })
    } else if (data.checkUsername !== 'AVAILABLE') {
      this.setState({
        usernameRes: 'Username already exist'
      })
    }
  }

  checkContactpValidity = () => {
    const regex = new RegExp(/^[a-zA-Z\s]{3,32}$/)

    this.setState({
      isContactpValid1: regex.test(this.state.contactPerson)
    })
  }

  checkContactpValidityTwo = () => {
    const regex = new RegExp(/^[a-zA-Z\s]{3,32}$/)

    this.setState({
      isContactpValid2: regex.test(this.state.secondaryContactName)
    })
  }

  checkPasswordValidity = () => {
    // const regex = new RegExp(/^[a-zA-Z0-9.\-_$@*!#]{3,20}$/)
    const regex = new RegExp(/^[a-zA-Z0-9!@#$&()\\-`.+,/"]{3,20}$/)
    this.setState({
      isPasswordValid:
        this.state.password !== '' && regex.test(this.state.password)
    })
  }

  checkPhonenoValidity1 = client => async event => {
    const regex = new RegExp(/^(\+91[-\s]?)?[0]?(91)?[1-9]\d{8,19}$/)
    const { data } = await client.query({
      query: GET_CONTACTNO,
      variables: { contactNumber: this.state.contactNumber }
    })

    this.setState({
      isPhoneExists: data.checkClientContactNumber === 'AVAILABLE',
      isPhonenoValid1: regex.test(this.state.contactNumber)
    })
  }

  checkPhonenoValidity2 = client => async event => {
    const regex = new RegExp(/^(\+91[-\s]?)?[0]?(91)?[1-9]\d{8,19}$/)

    if (this.state.secondaryContactNumber !== '') {
      this.setState({
        isPhonenoValid2: regex.test(this.state.secondaryContactNumber)
      })

      if (regex.test(this.state.secondaryContactNumber) === false) {
        this.setState({ phonenoRes2: 'Invalid phone number' })
      }
    }
  }

  checkEmailValidity1 = client => async event => {
    const regex = new RegExp(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    )
    const { data } = await client.query({
      query: GET_EMAIL,
      variables: { email: this.state.email }
    })
    this.setState({
      isEmailExists: data.checkClientEmail === 'AVAILABLE',
      isEmailValid1: regex.test(this.state.email)
    })
  }

  checkEmailValidity2 = client => async event => {
    const regex = new RegExp(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    )
    if (this.state.secondaryEmail !== '') {
      this.setState({
        isEmailValid2: regex.test(this.state.secondaryEmail)
      })
      if (regex.test(this.state.secondaryEmail) === false) {
        this.setState({ emailRes2: 'Invalid Email' })
      }
    }
  }
  checkAddressValidity = () => {
    // const regex = new RegExp(/^[a-zA-Z0-9\s,.'-]{3,300}$/)

    const regex = new RegExp(/^(.{5,200})$/)
    const regex2 = new RegExp(/^[^\s]+(\s+[^\s]+)*$/)
    this.setState({
      isAddressValid:
        regex.test(this.state.address) && regex2.test(this.state.address)
    })
  }

  checkShippingAddressValidity = () => {
    // const regex = new RegExp(/^[a-zA-Z0-9\s,.'-]{3,300}$/)

    const regex = new RegExp(/^(.{5,200})$/)
    const regex2 = new RegExp(/^[^\s]+(\s+[^\s]+)*$/)
    this.setState({
      isShippingAddressValid:
        regex.test(this.state.shippingAddress) &&
        regex2.test(this.state.shippingAddress)
    })
  }

  checkCountryValidity = () => {
    this.setState({
      isCountryValid: this.state.country !== ''
    })
  }

  checkCountryValidity2 = () => {
    this.setState({
      isCountryValid: this.state.shippingCountry !== ''
    })
  }

  checkCityValidity = arg => {
    const regex = new RegExp(/^[a-zA-Z]+(?:[\s-][a-zA-Z]+)*$/)

    if (arg === 'billing') {
      this.setState({
        isCityValid: regex.test(this.state.city) && this.state.city !== ''
      })
    } else if (arg === 'shipping') {
      this.setState({
        isShippingCityValid:
          regex.test(this.state.shippingCity) && this.state.city !== ''
      })
    }
  }

  checkPinValidity = () => {
    this.setState({ isPinValid: true })
    if (this.state.pincode !== null && this.state.pincode !== '') {
      const regex = new RegExp(/^[1-9][0-9]{5}$/)
      this.setState({
        isPinValid: regex.test(this.state.pincode)
      })
    }
  }
  checkPinValidity2 = () => {
    this.setState({ isShippingPinvalid: true })
    if (
      this.state.shippingPincode !== null &&
      this.state.shippingPincode !== ''
    ) {
      const regex = new RegExp(/^[1-9][0-9]{5}$/)
      this.setState({
        isShippingPinvalid: regex.test(this.state.shippingPincode)
      })
    }
  }

  checkPanValidity = client => async event => {
    // console.log(this.state.pan, 'pan')
    this.setState({ panNoRes: '' })
    if (this.state.pan !== null && this.state.pan !== '') {
      const regex = new RegExp(/([A-Z]){5}([0-9]){4}([A-Z]){1}$/)
      const { data } = await client.query({
        query: GET_PAN_NUMBER,
        variables: { pan: this.state.pan }
      })

      this.setState({
        isPanValid: regex.test(this.state.pan),
        isPanExists: data.checkClientPanNumber === 'AVAILABLE'
      })
    }
  }

  checkGSTValidity = async gstNumber => {
    if (this.state.gst !== null && this.state.gst !== '') {
      // const regex = new RegExp(/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9]{1}Z[a-zA-Z0-9]{1}$/)
      const regex = new RegExp(
        /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/
      )
      const { data } = await this.props.client.query({
        query: GET_GST_NUMBER,
        variables: { gst: this.state.gst },
        fetchPolicy: 'network-only'
      })

      this.setState({
        isGSTExists: data.checkClientGST === 'AVAILABLE',
        isGSTValid: regex.test(this.state.gst)
      })

      if (!this.state.isGSTValid) {
        this.setState({
          gstErrorFieldText: 'Invalid GST Number.'
        })
      }

      if (this.state.isGSTExists == false) {
        this.setState({ gstErrorFieldText: 'GST Number already registered.' })
      }

      if (this.state.isGSTValid && this.state.isGSTExists) {
        this.setState({
          gstErrorFieldText: '',
          panNumber: '',
          gstCompanyName: '',
          address: '',
          pincode: ''
        })

        await this.getGstInfo(gstNumber)
        if (!this.state.isGstInfoAvailable) {
          this.setState({ gstErrorFieldText: 'Invalid GST Number.' })
        }
      } else {
        this.setState({
          panNumber: '',
          gstCompanyName: '',
          address: '',
          pincode: ''
        })
      }
    } else {
      this.setState({
        panNumber: '',
        gstCompanyName: '',
        address: '',
        pincode: ''
      })
    }
  }

  handleCancelClick = e => {
    this.setState({ isCancelConfDialogOpen: true })
  }

  handleBackCancelClick = e => {
    if (
      // this.state.name === '' &&
      this.state.username === '' &&
      this.state.clientName === '' &&
      this.state.contactPerson === '' &&
      this.state.secondaryContactName === '' &&
      this.state.password === '' &&
      this.state.email === '' &&
      this.state.secondaryEmail === '' &&
      this.state.contactNumber === '' &&
      this.state.secondaryContactNumber === '' &&
      this.state.address === '' &&
      // this.state.address2 === '' &&
      this.state.shippingAddress === '' &&
      this.state.shippingAddress2 === '' &&
      this.state.shippingCity == '' &&
      this.shippingCountry == '' &&
      this.shippingState == '' &&
      this.state.shippingPincode == '' &&
      this.state.city === '' &&
      this.state.state === '' &&
      this.state.country === '' &&
      this.state.countryTwo === '' &&
      this.state.plan === '' &&
      this.state.timezone === '' &&
      this.state.solution === '' &&
      this.state.pincode === '' &&
      this.state.pan === '' &&
      this.state.gst === '' &&
      this.state.minimumTrackedDays === '' &&
      this.state.prorata === '' &&
      this.state.addressEffectiveDate == ''
    ) {
      this.cancelForm()
    } else {
      this.setState({ isCancelConfDialogOpen: true })
    }
  }

  handleSaveClick = async e => {
    const response = await this.props.client.mutate({
      mutation: ADD_CLIENTS,
      // variables:{

      // },
      errorPolicy: 'all',
      refetchQueries: ['allClientDetails']
    })

    this.setState({ isSaveConfDialogOpen: true })
  }

  handleCancelNegativeResponse = e => {
    this.setState({ isCancelConfDialogOpen: false })
  }

  handleSaveNegativeResponse = e => {
    this.setState({ isSaveConfDialogOpen: false })
  }

  submitForm = async e => {
    let variables
    e.preventDefault()
    const planId = this.state.plan
    if (this.state.customerType == 'Registered') {
      variables = {
        username: this.state.username,
        password: this.state.password,
        accountType: 'CLT',
        // clientName: this.state.clientName,
        clientName: this.state.gstCompanyName,
        email: this.state.email,
        secondaryEmail: this.state.secondaryEmail,
        contactPerson: this.state.contactPerson,
        secondaryContactName: this.state.secondaryContactName,
        contactNumber: this.state.contactNumber,
        secondaryContactNumber: this.state.secondaryContactNumber,
        // address: this.state.address,
        address: this.state.address,
        city: this.state.city,
        state: parseInt(this.state.state.value, 10),
        country: parseInt(this.state.country, 10),
        shippingCountry: parseInt(this.state.shippingCountry, 10),
        shippingState: parseInt(this.state.shippingState.value, 10),
        // countryTwo: parseInt(this.state.countryTwo, 10),
        // pincode: parseInt(this.state.pincode, 10),
        pincode: parseInt(this.state.pincode, 10),
        // panNumber: this.state.pan,
        panNumber: this.state.panNumber,
        // shippingAddress:
        //   this.state.shippingAddress + ' ' + this.state.shippingAddress2,
        shippingAddress: this.state.shippingAddress + ' ',
        shippingCity: this.state.shippingCity,
        shippingPincode: parseInt(this.state.shippingPincode, 10),
        minimumTrackedDays: parseInt(this.state.minimumTrackedDays, 10),
        packetThreshold: parseInt(this.state.packetThreshold, 10),
        prorata: this.state.prorata,
        addressEffectiveDate: this.state.addressEffectiveDate,
        partnerLoginId: getLoginId(),
        clientType: 'Live',
        subscriptionPlan: 'prepaid',
        // periodicity: 1,
        planId: parseInt(planId, 10),
        timezone: this.state.timezone,
        gst: this.state.gst,
        typeOfClient: this.state.typeOfClient,
        registrationType: this.state.customerType,
        solution: this.state.solution,
        billingMode: parseInt(this.state.billingMode, 10),
        salesPersonId: this.state.salesPerson
      }
    } else {
      variables = {
        username: this.state.username,
        password: this.state.password,
        accountType: 'CLT',
        // clientName: this.state.clientName,
        clientName: this.state.clientName,
        email: this.state.email,
        secondaryEmail: this.state.secondaryEmail,
        contactPerson: this.state.contactPerson,
        secondaryContactName: this.state.secondaryContactName,
        contactNumber: this.state.contactNumber,
        secondaryContactNumber: this.state.secondaryContactNumber,
        // address: this.state.address,
        address: this.state.address,
        city: this.state.city,
        state: parseInt(this.state.state.value, 10),
        country: parseInt(this.state.country, 10),
        shippingCountry: parseInt(this.state.shippingCountry, 10),
        shippingState: parseInt(this.state.shippingState.value, 10),
        // countryTwo: parseInt(this.state.countryTwo, 10),
        // pincode: parseInt(this.state.pincode, 10),
        pincode: parseInt(this.state.pincode, 10),
        // panNumber: this.state.pan,
        // panNumber: this.state.panNumber,
        // shippingAddress:
        //   this.state.shippingAddress + ' ' + this.state.shippingAddress2,
        shippingAddress: this.state.shippingAddress + ' ',
        shippingCity: this.state.shippingCity,
        shippingPincode: parseInt(this.state.shippingPincode, 10),
        minimumTrackedDays: parseInt(this.state.minimumTrackedDays, 10),
        packetThreshold: parseInt(this.state.packetThreshold, 10),
        prorata: this.state.prorata,
        addressEffectiveDate: this.state.addressEffectiveDate,
        partnerLoginId: getLoginId(),
        clientType: 'Live',
        subscriptionPlan: 'prepaid',
        // periodicity: 1,
        planId: parseInt(planId, 10),
        timezone: this.state.timezone,
        gst: this.state.gst,
        typeOfClient: this.state.typeOfClient,
        registrationType: this.state.customerType,
        solution: this.state.solution,
        billingMode: parseInt(this.state.billingMode, 10),
        salesPersonId: this.state.salesPerson
      }
    }

    // console.log(variables.address)

    if (this.state.typeOfClient === 'NON-COMMERCIAL') {
      variables['expiryDate'] = moment(this.state.expiryDateTime)
        .unix()
        .toString()
      console.log("variables['expiryDate']", variables['expiryDate'])
    }
    console.log('after if')
    if (!this.state.plan) {
      this.props.openSnackbar('Select a valid plan')
    } else {
      var { data, errors } = await this.props.client.mutate({
        mutation: ADD_CLIENTS,
        variables,
        errorPolicy: 'all',
        refetchQueries: ['allClientDetails']
      })
      console.log(data, errors)

      if (data) {
        this.props.openSnackbar('Registered Successfully')
        this.setState({
          clientName: '',
          username: '',
          contactPerson: '',
          secondaryContactName: '',
          password: '',
          email: '',
          secondaryEmail: '',
          contactNumber: '',
          secondaryContactNumber: '',
          address1: '',
          // address2: '',
          shippingAddress: '',
          // shippingAddress2: '',

          shippingPincode: '',
          minimumTrackedDays: '',
          prorata: '',
          addressEffectiveDate: '',

          city: '',
          shippingCity: '',
          state: '',
          country: '',
          secondaryCountry: '',
          secondaryState: '',
          pincode: '',
          pan: '',
          gst: '',
          panNumber: '',
          gstCompanyName: '',

          plan: '',
          timezone: '',
          typeOfClient: 'REAL',
          customerType: 'International',
          response: true,
          expiryDateTime: moment().add(1, 'week'),
          solution: '',
          billingMode: '',
          salesPerson: ''
        })
        this.props.history.push({
          pathname: '/home/customers/'
        })
      } else {
        this.props.openSnackbar(errors[0].message)
      }
    }
  }

  cancelForm = e => {
    // this.setState({
    //   name: '',
    //   username: '',
    //   person: '',
    //   password: '',
    //   email: '',
    //   phoneno: '',
    //   address1: '',
    //   address2: '',
    //   city: '',
    //   state: '',
    //   country: '',
    //   pincode: '',
    //   pan: '',
    //   gst: '',
    //   plan: '',
    //   timezone: '',
    //   typeOfClient: 'REAL',
    //   expiryDateTime: moment().add(1, 'week')
    // })
    this.props.history.goBack()
  }

  getGstInfo = async gstNumber => {
    const fetchGstData = await this.props.client.query({
      query: GET_GST_INFO,
      variables: {
        gstNumber: gstNumber
      }
    })

    this.setState({
      isGstInfoAvailable: fetchGstData.data.getGstDetails.status === 'SUCCESS',
      panNumber:
        fetchGstData.data.getGstDetails.panNumber != null
          ? fetchGstData.data.getGstDetails.panNumber
          : null,
      gstCompanyName:
        fetchGstData.data.getGstDetails.companyName != null
          ? fetchGstData.data.getGstDetails.companyName
          : null,
      address:
        fetchGstData.data.getGstDetails.address != null
          ? fetchGstData.data.getGstDetails.address
          : null,
      pincode:
        fetchGstData.data.getGstDetails.pinCode != null
          ? fetchGstData.data.getGstDetails.pinCode
          : null
    })
  }

  render() {
    // console.log(this.props)
    const {
      // name,
      username,
      clientName,
      companyName,
      contactPerson,
      secondaryContactName,
      password,
      email,
      secondaryEmail,
      contactNumber,
      secondaryContactNumber,
      address,
      address2,
      shippingAddress,
      shippingAddres2,
      shippingCountry,
      shippingState,
      shippingCity,
      shippingPincode,
      minimumTrackedDays,
      packetThreshold,
      prorata,
      addressEffectiveDate,

      city,

      state,
      state2,
      country,
      countryTwo,
      pincode,
      isGstInfoAvailable,
      panNumber,
      gstCompanyName,
      gstErrorFieldText,
      pan,
      gst,
      plan,
      typeOfClient,
      customerType,
      registrationType,
      solution,
      billingMode,
      salesPerson,
      allSalesPerson,
      packetsPerDay
    } = this.state

    const { classes } = this.props

    return (
      <ApolloConsumer>
        {client => (
          <Query
            query={GET_ALL_PLANS} // Fetch Billing Modes here
            variables={{
              partnerLoginId: getLoginId()
            }}
          >
            {({ loading, error, data: { allPlans } }) => {
              if (loading) return <Loader />

              if (error) return `Error!: ${error}`
              const plans = allPlans.map(plan => ({
                value: plan.id,
                label: plan.planName
              }))

              return (
                <div className={classes.root}>
                  <ConfirmationalDialog
                    isDialogOpen={this.state.isSaveConfDialogOpen}
                    dialogMessage={
                      "Are you sure you want to Save this customer's details?"
                    }
                    negativeResponseHandler={this.handleSaveNegativeResponse}
                    positiveResponseHandler={this.submitForm}
                  />
                  <ConfirmationalDialog
                    isDialogOpen={this.state.isCancelConfDialogOpen}
                    dialogMessage={
                      'Are you sure you want to Cancel customer registration?'
                    }
                    negativeResponseHandler={this.handleCancelNegativeResponse}
                    positiveResponseHandler={this.cancelForm}
                  />
                  <Grid container spacing={16}>
                    <Grid item container xs={12} justify="flex-start">
                      <Button
                        variant="outlined"
                        color="secondary"
                        className={classes.button}
                        onClick={this.handleBackCancelClick}
                      >
                        <ArrowBackIcon />
                      </Button>
                    </Grid>
                    <Grid item xs={12}>
                      <Card>
                        <CardHeader
                          title="Register Customer"
                          subheader="All fields marked with (*) are mandatory"
                          subheaderTypographyProps={{
                            className: classes.italicizedText
                          }}
                        />
                        <CardContent>
                          <Grid container spacing={16}>
                            {/* <Grid item xs={12} md={6}>
                              <FormControl>
                                <RadioGroup
                                  aria-label="position"
                                  name="position"
                                  value={typeOfClient}
                                  onChange={this.handleTypeChange}
                                  row
                                >
                                  <FormControlLabel
                                    value="REAL"
                                    control={<Radio color="primary" />}
                                    label="Billable"
                                    labelPlacement="end"
                                  />
                                  <FormControlLabel
                                    value="DEMO"
                                    control={<Radio color="primary" />}
                                    label="Non-Billable"
                                    labelPlacement="end"
                                  />
                                </RadioGroup>
                              </FormControl>
                            </Grid> */}
                            {/* <Grid item xs={12} md={12}>
                              <FormGroup className="form-input">
                                <TextField
                                  name="clientName"
                                  value={clientName}
                                  type="text"
                                  onChange={this.handleInputChange}
                                  onInput={e =>
                                    (e.target.value = (
                                      '' + e.target.value
                                    ).toUpperCase())
                                  }
                                  required
                                  label="Company Name"
                                />
                              </FormGroup>
                            </Grid> */}

                            <Grid item xs={12} md={6}>
                              <FormGroup className="form-input">
                                <Select
                                  options={CUSTOMER_TYPES}
                                  value={customerType}
                                  onChange={this.handleCustomerTypeChange}
                                  placeholder="Customer Type"
                                />
                              </FormGroup>
                            </Grid>

                            <Grid item xs={12} md={6}>
                              <FormGroup className="form-input">
                                <Select
                                  options={TYPE_OF_CLIENT}
                                  value={typeOfClient}
                                  onChange={this.handleClientType}
                                  placeholder="Type Of Client*"
                                  required
                                />
                              </FormGroup>
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <DateTimePicker
                                label="Expiry Date &amp; Time"
                                disabled={
                                  typeOfClient.value === 'REAL' ||
                                  typeOfClient == 'REAL' ||
                                  typeOfClient === ''
                                }
                                value={this.state.expiryDateTime}
                                onChange={this.handleDateTimeChange}
                                inputProps={{
                                  name: 'expiryDateTime'
                                }}
                              />
                            </Grid>

                            {/* {typeOfClient.value === 'NON-COMMERCIAL' && (
                              <Grid item xs={12} md={6}>
                                <DateTimePicker
                                  label="Expiry Date &amp; Time 11"
                                  // disabled={typeOfClient === 'REAL'}
                                  value={this.state.expiryDateTime}
                                  onChange={this.handleDateTimeChange}
                                  inputProps={{
                                    name: 'expiryDateTime'
                                  }}
                                />
                              </Grid>
                            )} */}
                            {/* <Grid item xs={12} md={6}>
                              <DateTimePicker
                                label="Expiry Date &amp; Time 11"
                                disabled={typeOfClient === 'REAL'}
                                value={this.state.expiryDateTime}
                                onChange={this.handleDateTimeChange}
                                inputProps={{
                                  name: 'expiryDateTime'
                                }}
                              />
                            </Grid> */}
                            {customerType === 'Registered' && (
                              <Grid item xs={12} md={6}>
                                <FormGroup className="form-input">
                                  <TextField
                                    name="gst"
                                    value={gst}
                                    type="text"
                                    onChange={this.handleInputChange}
                                    label="GST"
                                    required
                                    error={!this.state.isGSTValid}
                                    onBlur={() =>
                                      this.checkGSTValidity(this.state.gst)
                                    }
                                  />
                                  <FormHelperText
                                    id="name-error-text"
                                    className="Error_msg"
                                  >
                                    {gstErrorFieldText}
                                  </FormHelperText>
                                </FormGroup>
                              </Grid>
                            )}
                            {(customerType === 'Registered' ||
                              customerType === 'Unegistered') && (
                              <Grid item xs={12} md={6}>
                                <FormGroup className="form-input">
                                  <TextField
                                    name="pan"
                                    value={
                                      this.state.panNumber != null
                                        ? this.state.panNumber
                                        : null
                                    }
                                    type="text"
                                    onChange={this.handleInputChange}
                                    label="PAN"
                                    required
                                    disabled
                                    error={!this.state.isPanValid}
                                    onBlur={this.checkPanValidity(client)}
                                  />
                                  <FormHelperText
                                    id="name-error-text"
                                    className="Error_msg"
                                  >
                                    {this.state.isPanExists
                                      ? ''
                                      : 'Pan No. Already Exists'}
                                    {this.state.isPanValid
                                      ? ''
                                      : 'Invalid Pan Number'}
                                  </FormHelperText>
                                </FormGroup>
                              </Grid>
                            )}
                            <Grid item xs={12} md={12}>
                              <FormGroup className="form-input">
                                <TextField
                                  name="clientName"
                                  value={
                                    this.state.customerType == 'Registered'
                                      ? this.state.gstCompanyName != null
                                        ? this.state.gstCompanyName
                                        : null
                                      : clientName
                                  }
                                  type="text"
                                  onChange={this.handleInputChange}
                                  onInput={e =>
                                    (e.target.value = (
                                      '' + e.target.value
                                    ).toUpperCase())
                                  }
                                  required
                                  disabled={
                                    this.state.customerType == 'Registered'
                                  }
                                  label="Company Name"
                                  error={!this.state.isNameValid}
                                  onBlur={this.checkNameValidity}
                                />
                                <FormHelperText
                                  id="name-error-text"
                                  className="Error_msg"
                                >
                                  {this.state.isNameValid ? '' : 'Invalid'}
                                </FormHelperText>
                              </FormGroup>
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <FormGroup className="form-input">
                                <Select
                                  options={SOLUTION_TYPES}
                                  value={solution}
                                  onChange={this.handleSolutionChange}
                                  placeholder="Select Solution*"
                                />
                              </FormGroup>
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <FormGroup className="form-input">
                                <Select
                                  options={plans}
                                  value={plan}
                                  onChange={this.handlePlanChange}
                                  placeholder="Select Plan *"
                                />
                              </FormGroup>
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <FormGroup className="form-input">
                                <Select
                                  options={this.state.timezoneList}
                                  value={this.state.timezone}
                                  onChange={this.handleTimezoneChange}
                                  placeholder="Select Time Zone *"
                                />
                              </FormGroup>
                            </Grid>
                            {getLoginId() === 2 && (
                              <Grid item xs={12} md={6}>
                                <FormGroup className="form-input">
                                  <Select
                                    options={allSalesPerson}
                                    value={salesPerson}
                                    onChange={this.handleSalesPersonChange}
                                    placeholder="Select Sales Person*"
                                  />
                                </FormGroup>
                              </Grid>
                            )}
                            <Grid item xs={12} md={6}>
                              <FormGroup className="form-input">
                                <TextField
                                  name="username"
                                  value={username}
                                  type="text"
                                  onChange={this.handleInputChange}
                                  required
                                  error={!this.state.isUsernameValid}
                                  onBlur={this.checkUsernameValidity(client)}
                                  label="User Name"
                                />
                                <FormHelperText
                                  id="name-error-text"
                                  className="Error_msg"
                                >
                                  {!this.state.isUsernameValid
                                    ? this.state.usernameRes
                                    : ''}
                                </FormHelperText>
                              </FormGroup>
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <FormGroup className="form-input">
                                <TextField
                                  name="password"
                                  value={password}
                                  type="password"
                                  onChange={this.handleInputChange}
                                  label="Password"
                                  error={!this.state.isPasswordValid}
                                  onBlur={this.checkPasswordValidity}
                                  required
                                />
                                <FormHelperText
                                  id="name-error-text"
                                  className="Error_msg"
                                >
                                  {this.state.isPasswordValid
                                    ? ''
                                    : 'Password should contain 3-20 charcter or digit without space'}
                                </FormHelperText>
                              </FormGroup>
                            </Grid>
                            <Grid item xs={12} md={12}>
                              {/* <FormGroup className="form-input" display="flex"> */}
                              {/* <label> */}
                              <Checkbox
                                name="prorata"
                                value={prorata}
                                checked={prorata}
                                onClick={this.handleProrataCheckboxChange}
                                onChange={this.setProrata}
                              />
                              <span style={{ fontSize: '20px' }}>
                                Prorata Billing
                              </span>
                              {/* </label> */}
                              {/* </FormGroup> */}
                            </Grid>
                            {this.state.prorata ? (
                              <Grid item xs={12} md={6}>
                                <FormGroup className="form-input">
                                  <TextField
                                    name="packetThreshold"
                                    value={packetThreshold}
                                    type="text"
                                    onChange={this.handleProrata}
                                    label="Packets per Day"
                                    required
                                  />
                                </FormGroup>
                              </Grid>
                            ) : null}
                            {this.state.prorata ? (
                              <Grid item xs={12} md={6}>
                                <FormGroup className="form-input">
                                  <TextField
                                    name="minimumTrackedDays"
                                    value={minimumTrackedDays}
                                    type="text"
                                    onChange={this.handleProrata}
                                    label="Minium Tracking Days"
                                    required
                                  />
                                </FormGroup>
                              </Grid>
                            ) : null}
                            {/* <Grid item xs={12} md={6}>
                              <FormGroup className="form-input">
                                <TextField
                                  name="name"
                                  value={name}
                                  type="text"
                                  onChange={this.handleInputChange}
                                  label="Full Name"
                                  onInput={(e) => (e.target.value = (""+e.target.value).toUpperCase())}
                                  required
                                  error={!this.state.isNameValid}
                                  onBlur={this.checkNameValidity(client)}
                                />
                                <FormHelperText
                                  id="name-error-text"
                                  className="Error_msg"
                                >
                                  {this.state.isNameValid
                                    ? ''
                                    : this.state.clientNameRes}
                                </FormHelperText>
                              </FormGroup>
                            </Grid> */}
                            <Grid item xs={12} md={6}>
                              <FormGroup className="form-input">
                                <Select
                                  options={BILLING_MODES}
                                  value={billingMode}
                                  onChange={this.hanldeBillingModeChange}
                                  placeholder="Select Billing Mode*"
                                />
                              </FormGroup>
                            </Grid>
                            <Grid item xs={12} md={12}>
                              <p style={{ fontSize: '24px' }}>Contact Info</p>
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <FormGroup className="form-input">
                                <TextField
                                  name="contactPerson"
                                  value={contactPerson}
                                  type="text"
                                  onChange={this.handleInputChange}
                                  label="Primary Contact Person"
                                  required
                                  error={!this.state.isContactpValid1}
                                  onBlur={this.checkContactpValidity}
                                />
                                <FormHelperText
                                  id="name-error-text"
                                  className="Error_msg"
                                >
                                  {this.state.isContactpValid1
                                    ? ''
                                    : 'Only Alphabets allowed, between 3 to 32 characters'}
                                </FormHelperText>
                              </FormGroup>
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <FormGroup className="form-input">
                                <TextField
                                  name="secondaryContactName"
                                  value={secondaryContactName}
                                  type="text"
                                  onChange={this.handleInputChange}
                                  label="Secondary Contact Person"
                                  error={!this.state.isContactpValid2}
                                  onBlur={this.checkContactpValidityTwo}
                                />
                                <FormHelperText
                                  id="name-error-text"
                                  className="Error_msg"
                                >
                                  {this.state.isContactpValid2
                                    ? ''
                                    : 'Only Alphabets allowed, between 3 to 32 characters'}
                                </FormHelperText>
                              </FormGroup>
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <FormGroup className="form-input">
                                <TextField
                                  name="email"
                                  value={email}
                                  type="email"
                                  onChange={this.handleInputChange}
                                  label="Primary Email"
                                  required
                                  error={!this.state.isEmailValid1}
                                  onBlur={this.checkEmailValidity1(client)}
                                />
                                <FormHelperText
                                  id="name-error-text"
                                  className="Error_msg"
                                >
                                  {this.state.isEmailExists
                                    ? ''
                                    : 'Email Id already exist '}
                                  {this.state.isEmailValid1
                                    ? ' '
                                    : 'Invalid Email '}
                                </FormHelperText>
                              </FormGroup>
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <FormGroup className="form-input">
                                <TextField
                                  name="secondaryEmail"
                                  value={secondaryEmail}
                                  type="email"
                                  onChange={this.handleInputChange}
                                  label="Secondary Email"
                                  error={!this.state.isEmailValid2}
                                  onBlur={this.checkEmailValidity2(
                                    this.props.client
                                  )}
                                />
                                <FormHelperText
                                  id="name-error-text"
                                  className="Error_msg"
                                >
                                  {this.state.isEmailValid2
                                    ? ''
                                    : 'Invalid Email'}
                                </FormHelperText>
                              </FormGroup>
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <FormGroup className="form-input">
                                <TextField
                                  name="contactNumber"
                                  value={contactNumber}
                                  type="text"
                                  onChange={this.handleInputChange}
                                  label="Primary Phone Number"
                                  required
                                  error={!this.state.isPhonenoValid1}
                                  onBlur={this.checkPhonenoValidity1(client)}
                                />
                                <FormHelperText
                                  id="name-error-text"
                                  className="Error_msg"
                                >
                                  {this.state.isPhonenoValid1
                                    ? ''
                                    : 'Invalid Phone Number '}
                                  {this.state.isPhoneExists
                                    ? ' '
                                    : 'Phone Number Already Exists '}
                                </FormHelperText>
                              </FormGroup>
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <FormGroup className="form-input">
                                <TextField
                                  name="secondaryContactNumber"
                                  value={secondaryContactNumber}
                                  type="text"
                                  onChange={this.handleInputChange}
                                  label="Secondary Phone Number"
                                  error={!this.state.isPhonenoValid2}
                                  onBlur={this.checkPhonenoValidity2(client)}
                                />
                                <FormHelperText
                                  id="name-error-text"
                                  className="Error_msg"
                                >
                                  {this.state.isPhonenoValid2
                                    ? ''
                                    : 'Invalid phone Number'}
                                </FormHelperText>
                              </FormGroup>
                            </Grid>
                            <Grid item xs={12} md={12}>
                              <p style={{ fontSize: '24px' }}>
                                Billing Address
                              </p>
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <FormGroup className="form-input">
                                <TextField
                                  name="address"
                                  value={address}
                                  type="text"
                                  onChange={this.handleInputChange}
                                  label="Address Line 1"
                                  required
                                  error={!this.state.isAddressValid}
                                  onBlur={this.checkAddressValidity}
                                />
                                <FormHelperText
                                  id="name-error-text"
                                  className="Error_msg"
                                >
                                  {this.state.isAddressValid
                                    ? ''
                                    : 'Address should be between 5 to 200 characters without spaces at Start and End.'}
                                </FormHelperText>
                              </FormGroup>
                            </Grid>
                            <Grid item xs={12} md={6}>
                              {/* <FormGroup className="form-input">
                                <TextField
                                  name="address2"
                                  value={address2}
                                  type="text"
                                  onChange={this.handleInputChange}
                                  label="Address Line 2"
                                  required
                                  error={!this.state.isAddressValid}
                                  onBlur={this.checkAddressValidity2}
                                />
                              </FormGroup> */}
                            </Grid>
                            <Grid item xs={6}>
                              <FormGroup className="form-input">
                                {/* <TextField
                                      // autoComplete="username"
                                          name="country"
                                          value={this.props.country}
                                          type="text"
                                          onChange={this.props.handleInputChange}
                                          placeholder="Country"
                                          required
                                          // error={!isUsernameValid}
                                          handleCountryChange={this.props.handleCountryChange}
                                          />
                                        </FormGroup>
                                              </Grid>        // onBlur={this.checkUsernameValidity}
                                           // label={!isUsernameValid ? 'Invalid Username' : ''}
                                        /> */}
                                {/* <Countries
                                  value={this.country}
                                  handleCountryChange={this.handleCountryChange}
                                /> */}
                                <Query query={GET_COUNTRIES}>
                                  {({
                                    loading,
                                    error,
                                    data: { allCountries }
                                  }) => {
                                    if (loading) return 'Loading...'
                                    if (error) return `Error!: ${error}`

                                    const sortedCountries = allCountries.map(
                                      country => ({
                                        value: country.country_id,
                                        label: country.name
                                      })
                                    )

                                    return (
                                      <div>
                                        <Select
                                          // classes={classes}
                                          options={sortedCountries}
                                          // components={components}
                                          value={country}
                                          onChange={this.handleCountryChange}
                                          placeholder="Select Country *"
                                        />
                                      </div>
                                    )
                                  }}
                                </Query>
                              </FormGroup>
                            </Grid>

                            {this.state.country && (
                              <Grid item xs={12} md={6}>
                                <FormGroup className="form-input">
                                  <Query
                                    query={GET_STATES_FOR_COUNTRY}
                                    variables={{
                                      countryId: country
                                    }}
                                  >
                                    {({
                                      loading,
                                      error,
                                      data: { allStatesByCountryId }
                                    }) => {
                                      if (loading) return 'Loading...'
                                      if (error) return `Error: ${error}`

                                      const allStates = allStatesByCountryId.map(
                                        s => {
                                          return {
                                            value: s.zone_id,
                                            label: s.name
                                          }
                                        }
                                      )

                                      if (allStates.length > 0) {
                                        return (
                                          <Select
                                            options={allStates}
                                            value={state}
                                            onChange={this.handleStateChange}
                                            placeholder="Select State *"
                                          />
                                        )
                                      } else {
                                        return (
                                          <TextField
                                            value="No States in this Country"
                                            type="text"
                                          />
                                        )
                                      }
                                    }}
                                  </Query>
                                </FormGroup>
                              </Grid>
                            )}

                            {/* <Grid item xs={12} md={6}>
                              <FormGroup className="form-input">
                                <TextField
                                  name="state"
                                  value={state}
                                  type="text"
                                  onChange={this.handleInputChange}
                                  label="State"
                                  required
                                />
                              </FormGroup>
                            </Grid> */}
                            <Grid item xs={12} md={6}>
                              <FormGroup className="form-input">
                                <TextField
                                  name="city"
                                  value={city}
                                  type="text"
                                  onChange={this.handleInputChange}
                                  label="City"
                                  required
                                  error={!this.state.isCityValid}
                                  onBlur={() => {
                                    this.checkCityValidity('billing')
                                  }}
                                />
                                <FormHelperText
                                  id="name-error-text"
                                  className="Error_msg"
                                >
                                  {this.state.isCityValid ? '' : 'Invalid City'}
                                </FormHelperText>
                              </FormGroup>
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <FormGroup className="form-input">
                                <TextField
                                  name="pincode"
                                  value={pincode}
                                  type="text"
                                  onChange={this.handleInputChange}
                                  label="Pin"
                                  required
                                  error={!this.state.isPinValid}
                                  onBlur={this.checkPinValidity}
                                />
                                <FormHelperText
                                  id="name-error-text"
                                  className="Error_msg"
                                >
                                  {this.state.isPinValid ? '' : 'Invalid Pin'}
                                </FormHelperText>
                              </FormGroup>
                            </Grid>
                            <Grid item xs={12} md={12}>
                              <p style={{ fontSize: '24px' }}>
                                Shipping Address
                              </p>
                            </Grid>
                            <Grid item xs={12} md={12} display="flex">
                              {/* <FormGroup className="form-input" display="flex"> */}
                              {/* <label> */}
                              <Checkbox
                                name="shipping"
                                value={this.state.shippingmode}
                                // checked={
                                //   // this.state.shippingmode
                                //   // ? this.setState({ shippingmode: true })
                                //   // : this.setState({ shippingmode: false })
                                // }
                                onClick={this.handleShipping}
                              />

                              <span style={{ fontSize: '15px' }}>
                                Same as billing
                              </span>
                              {/* </label> */}
                              {/* </FormGroup> */}
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <FormGroup className="form-input">
                                <TextField
                                  name="shippingAddress"
                                  value={shippingAddress}
                                  type="text"
                                  onChange={this.handleInputChange}
                                  label="Address Line 1"
                                  error={!this.state.isShippingAddressValid}
                                  onBlur={this.checkShippingAddressValidity}
                                  required
                                />
                                <FormHelperText
                                  id="name-error-text"
                                  className="Error_msg"
                                >
                                  {this.state.isShippingAddressValid
                                    ? ''
                                    : 'Shipping Address should be between 5 to 200 characters without spaces at Start and End.'}
                                </FormHelperText>
                              </FormGroup>
                            </Grid>
                            <Grid item xs={12} md={6}>
                              {/* <FormGroup className="form-input">
                                <TextField
                                  name="shippingAddress2"
                                  value={shippingAddres2}
                                  type="text"
                                  onChange={this.handleInputChange}
                                  label="Address Line 2"
                                  error={!this.state.isAddressValid}
                                  onBlur={this.checkAddressValidity2}
                                />
                              </FormGroup> */}
                            </Grid>

                            <Grid item xs={6}>
                              <FormGroup className="form-input">
                                <Query query={GET_COUNTRIES}>
                                  {({
                                    loading,
                                    error,
                                    data: { allCountries }
                                  }) => {
                                    if (loading) return 'Loading...'
                                    if (error) return `Error!: ${error}`

                                    const sortedCountries = allCountries.map(
                                      country => ({
                                        value: country.country_id,
                                        label: country.name
                                      })
                                    )

                                    return (
                                      <div>
                                        <Select
                                          // classes={classes}
                                          options={sortedCountries}
                                          // components={components}
                                          value={shippingCountry}
                                          onChange={
                                            this.handleSecondaryCountryChange
                                          }
                                          placeholder="Select Country *"
                                        />
                                      </div>
                                    )
                                  }}
                                </Query>{' '}
                              </FormGroup>
                            </Grid>

                            {this.state.shipping ? (
                              <Grid item xs={12} md={6}>
                                <FormGroup className="form-input">
                                  <Select
                                    value={state}
                                    placeholder="Select State *"
                                  />
                                </FormGroup>
                              </Grid>
                            ) : (
                              this.state.shippingCountry && (
                                <Grid item xs={12} md={6}>
                                  <FormGroup className="form-input">
                                    <Query
                                      query={GET_STATES_FOR_COUNTRY}
                                      variables={{
                                        countryId: shippingCountry
                                      }}
                                    >
                                      {({
                                        loading,
                                        error,
                                        data: { allStatesByCountryId }
                                      }) => {
                                        if (loading) return 'Loading...'
                                        if (error) return `Error: ${error}`

                                        const allStates = allStatesByCountryId.map(
                                          s => {
                                            return {
                                              value: s.zone_id,
                                              label: s.name
                                            }
                                          }
                                        )

                                        if (allStates.length > 0) {
                                          return (
                                            <Select
                                              options={allStates}
                                              value={shippingState}
                                              onChange={
                                                this.handleStateChangeTwo
                                              }
                                              placeholder="Select State *"
                                            />
                                          )
                                        } else {
                                          return (
                                            <TextField
                                              value="No States in this Country"
                                              type="text"
                                            />
                                          )
                                        }
                                      }}
                                    </Query>
                                  </FormGroup>
                                  {/* {
                                    this.state.shipping && 
                                  } */}
                                </Grid>
                              )
                            )}
                            {/* 
                            <Grid item xs={12} md={6}>
                              <FormGroup className="form-input">
                                <TextField
                                  name="state2"
                                  value={this.state.shipping ? state : state2}
                                  type="text"
                                  onChange={this.handleInputChange}
                                  label="State"
                                  required
                                />
                              </FormGroup>
                            </Grid> */}
                            <Grid item xs={12} md={6}>
                              <FormGroup className="form-input">
                                <TextField
                                  name="shippingCity"
                                  value={shippingCity}
                                  type="text"
                                  onChange={this.handleInputChange}
                                  label="City"
                                  error={!this.state.isShippingCityValid}
                                  onBlur={() => {
                                    this.checkCityValidity('shipping')
                                  }}
                                  required
                                />
                                <FormHelperText
                                  id="name-error-text"
                                  className="Error_msg"
                                >
                                  {this.state.isShippingCityValid
                                    ? ''
                                    : 'Invalid City'}
                                </FormHelperText>
                              </FormGroup>
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <FormGroup className="form-input">
                                <TextField
                                  name="shippingPincode"
                                  value={shippingPincode}
                                  type="text"
                                  onChange={this.handleInputChange}
                                  label="Pin"
                                  // error={!this.state.isPinValid}
                                  error={!this.state.isShippingPinvalid}
                                  onBlur={this.checkPinValidity2}
                                  required
                                />
                                <FormHelperText
                                  id="name-error-text"
                                  className="Error_msg"
                                >
                                  {this.state.isShippingPinvalid
                                    ? ''
                                    : 'Invalid Pin'}
                                </FormHelperText>
                              </FormGroup>
                            </Grid>

                            {/* <Grid item xs={12}>
                              <CustomTabs
                                address={address}
                                city={city}
                                state={state}
                                country={country}
                                pincode={pincode}
                                pan={pan}
                                gst={gst}
                                isAddressValidity={this.checkCityValidity}
                                checkPinValidity={this.checkPinValidity}
                                checkPanValidity={this.checkPanValidity(client)}
                                checkGSTValidity={this.checkGSTValidity(client)}
                                panNoRes={this.state.panNoRes}
                                gstNoRes={this.state.gstNoRes}
                              />
                            </Grid> */}
                          </Grid>
                        </CardContent>
                        <CardActions>
                          <Button
                            color="secondary"
                            variant="contained"
                            onClick={this.submitForm}
                            disabled={
                              this.state.isEmailValid1 === false ||
                              // this.state.isEmailValid2 === false ||
                              this.state.isContactpValid1 === false ||
                              // this.state.isContactpValid2 === false ||
                              this.state.isPhonenoValid1 === false ||
                              // this.state.isPhonenoValid2 === false ||
                              this.state.isCityValid === false ||
                              this.state.isShippingAddressValid === false ||
                              this.state.isShippingCityValid === false ||
                              this.state.isPinValid === false ||
                              this.state.isPanValid === false ||
                              this.state.isAddressValid === false ||
                              // this.state.isUsernameValid === false ||
                              // this.state.isNameValid === false ||
                              // this.state.isPasswordValid === false ||
                              // this.state.isUsernameUnique === false ||
                              this.state.isGSTValid === false ||
                              (this.state.customerType === 'Registered' &&
                                this.state.gst === '') ||
                              (this.state.customerType === 'Registered' &&
                                this.state.panNumber === '') ||
                              (this.state.customerType === 'Registered' &&
                                this.state.gstCompanyName === '') ||
                              this.state.isShippingPinvalid === false ||
                              solution === '' ||
                              // clientName === '' ||
                              username === '' ||
                              // contactPerson === '' ||
                              // secondaryContactName === '' ||
                              salesPerson === '' ||
                              password === '' ||
                              email === '' ||
                              packetThreshold === '' ||
                              minimumTrackedDays === '' ||
                              // packetThreshold === null ||
                              // minimumTrackedDays === null
                              // secondaryEmail === '' ||
                              // secondaryContactNumber === '' ||
                              // contactNumber === '' ||
                              typeOfClient === '' ||
                              pincode === '' ||
                              address === '' ||
                              city === '' ||
                              state === '' ||
                              country === '' ||
                              // this.state.shippingmode === false ||
                              // plan === '' ||
                              this.state.shippingAddress === '' ||
                              this.state.shippingState === null ||
                              state === null ||
                              this.state.shippingCity === '' ||
                              this.state.shippingState === '' ||
                              this.state.shippingCountry === '' ||
                              this.state.shippingPincode === '' ||
                              this.state.timezone === '' ||
                              billingMode === ''
                            }
                          >
                            Save
                          </Button>
                          <Button
                            color="secondary"
                            onClick={this.handleCancelClick}
                          >
                            Cancel
                          </Button>
                        </CardActions>
                      </Card>
                    </Grid>
                  </Grid>
                </div>
              )
            }}
          </Query>
        )}
      </ApolloConsumer>
    )
  }
}

RegisterCustomer.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(
  withApollo(withSharedSnackbar(RegisterCustomer))
)



// WEBPACK FOOTER //
// ./src/components/Pages/RegisterCustomer/index.jsx